import React from "react";
import { H2, Loader } from "@shoptet/ui";
import { useTranslation } from "react-i18next";

type SmallLoaderProps = {
  size?: "sm" | "md" | "lg";
  text?: string;
  withText?: boolean;
};

export const SmallLoader = ({ size = "lg", text, withText }: SmallLoaderProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.SmallLoader" });
  const loadingText = text || t("default text");
  return (
    <div className="small-loader-container">
      <Loader size={size} />
      {withText && (
        <div style={{ width: "100%" }}>
          <H2 align="center" divider={false}>
            {loadingText}
          </H2>
        </div>
      )}
    </div>
  );
};
